<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading">
    <div
        class="flex flex-row items-center gap-5 font-semibold text[#424242] dark:text-white mb-4 mr-5 ml-0 cursor-pointer">
        <p (click)="navigateToReports()">Reports</p>
        <p onclick="history.back()">Officer Reports</p>
        <p>Monthly Report</p>
    </div>

    <div class="w-full px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg">
        <div class="flex flex-row items-center justify-center w-full">
            <p class="text-xl font-semibold text-[#292929] mx-3 dark:text-white">From :</p>

            <div class="mr-10 w-56">
                <app-custom-datepicker #fromDatePicker [selectedDate]="startDate"
                    (dateChange)="onStartDateChange($event)" placeholder="--Select Date--">
                </app-custom-datepicker>
            </div>

            <p class="text-xl font-semibold text-[#292929] mx-3 dark:text-white">To :</p>

            <div class="mr-6 w-56">
                <app-custom-datepicker #toDatePicker [selectedDate]="endDate" (dateChange)="onEndDateChange($event)"
                    placeholder="--Select Date--">
                </app-custom-datepicker>
            </div>

            <button (click)="filterDate()"
                class="bg-[#415CFF] text-lg text-white font-semibold px-6 py-2 rounded-lg shadow-lg ml-5 dark:text-white">Go</button>
        </div>


        <div *ngIf="hasData" class="flex justify-center items-center mt-10">
            <button (click)="downloadReport()"
                class="bg-[#415CFF] dark:text-white dark:bg-[#415CFF] text-lg text-white font-semibold px-6 py-2 rounded-lg shadow-lg ml-5">Download
                Report</button>
        </div>
    </div>

    <div *ngIf="!hasData"
        class="flex flex-col items-center w-full h-screen px-10 py-7 bg-tileLight dark:bg-[#363636] dark:text-textDark shadow-lg rounded-lg mt-6">
        <p class="text-[#494949] my-6 dark:text-textDark">--No Data Availabale--</p>
        <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20 dark:text-textDark" />
    </div>

    <div *ngIf="hasData" id="reportContainer"
        class="w-full px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg mt-6 mb-6">
        <div class="flex flex-col justify-center items-center">
            <p class="text-[#292929] font-semibold text-xl mt-4 mb-8 dark:text-white">Collection Officer Report</p>
        </div>

        <div class="grid grid-cols-2 gap-x-10 gap-y-6 ">
            <div class="flex">
                <span
                    class="inline-flex items-center px-4 text-[#292929] border font-semibold border-e border-[#D9D9D9] rounded-s-md dark:bg-[#292929] dark:text-textDark dark:border-gray-600">
                    From
                </span>
                <span
                    class="rounded-none rounded-e-lg border border-s-0 bg-gray-50 border-[#D9D9D9] font-semibold focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full p-2.5 dark:text-white dark:bg-[#1D1D1F] dark:border-gray-600">
                    {{ startDate | date: 'yyyy-MM-dd' }}
                </span>
            </div>


            <div class="flex">
                <span
                    class="inline-flex items-center px-4 text-[#292929] border font-semibold border-e border-[#D9D9D9] rounded-s-md dark:bg-[#292929] dark:text-textDark dark:border-gray-600">
                    To
                </span>
                <span
                    class="rounded-none rounded-e-lg border border-s-0 bg-gray-50 border-[#D9D9D9] font-semibold focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full p-2.5 dark:text-white dark:bg-[#1D1D1F] dark:border-gray-600">
                    {{endDate | date: 'yyyy-MM-dd'}}
                </span>
            </div>

            <div class="flex">
                <span
                    class="inline-flex items-center px-4 text-[#292929] border font-semibold border-e border-[#D9D9D9] rounded-s-md dark:bg-[#292929] dark:text-textDark dark:border-gray-600">
                    EMP ID
                </span>
                <span
                    class="rounded-none rounded-e-lg border border-s-0 bg-gray-50 border-[#D9D9D9] font-semibold focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full p-2.5 dark:text-white dark:bg-[#1D1D1F] dark:border-gray-600">
                    {{officerDataObj.empId}}
                </span>
            </div>

            <div class="flex">
                <span
                    class="inline-flex items-center px-4 text-[#292929] border font-semibold border-e border-[#D9D9D9] rounded-s-md dark:bg-[#292929] dark:text-textDark dark:border-gray-600">
                    Role
                </span>
                <span
                    class="rounded-none rounded-e-lg border border-s-0 bg-gray-50 border-[#D9D9D9] font-semibold focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full p-2.5 dark:text-white dark:bg-[#1D1D1F] dark:border-gray-600">
                    {{officerDataObj.jobRole}}
                </span>
            </div>

            <div class="flex">
                <span
                    class="inline-flex items-center px-4 text-[#292929] border font-semibold border-e border-[#D9D9D9] rounded-s-md dark:bg-[#292929] dark:text-textDark dark:border-gray-600">
                    First Name
                </span>
                <span
                    class="rounded-none rounded-e-lg border border-s-0 bg-gray-50 border-[#D9D9D9] font-semibold focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full p-2.5 dark:text-white dark:bg-[#1D1D1F] dark:border-gray-600">
                    {{officerDataObj.firstNameEnglish}}
                </span>
            </div>

            <div class="flex">
                <span
                    class="inline-flex items-center px-4 text-[#292929] border font-semibold border-e border-[#D9D9D9] rounded-s-md dark:bg-[#292929] dark:text-textDark dark:border-gray-600">
                    Last Name
                </span>
                <span
                    class="rounded-none rounded-e-lg border border-s-0 bg-gray-50 border-[#D9D9D9] font-semibold focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full p-2.5 dark:text-white dark:bg-[#1D1D1F] dark:border-gray-600">
                    {{officerDataObj.lastNameEnglish}}
                </span>
            </div>

            <div class="flex">
                <span
                    class="inline-flex items-center px-4 text-[#292929] border font-semibold border-e border-[#D9D9D9] rounded-s-md dark:bg-[#292929] dark:text-textDark dark:border-gray-600">
                    Weight
                </span>
                <span
                    class="rounded-none rounded-e-lg border border-s-0 bg-gray-50 border-[#D9D9D9] font-semibold focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full p-2.5 dark:text-white dark:bg-[#1D1D1F] dark:border-gray-600">
                    {{officerDataObj.TotalQty}} kg
                </span>
            </div>

            <div class="flex">
                <span
                    class="inline-flex items-center px-4 text-[#292929] border font-semibold border-e border-[#D9D9D9] rounded-s-md dark:bg-[#292929] dark:text-textDark dark:border-gray-600">
                    Collections
                </span>
                <span
                    class="rounded-none rounded-e-lg border border-s-0 bg-gray-50 border-[#D9D9D9] font-semibold focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full p-2.5 dark:text-white dark:bg-[#1D1D1F] dark:border-gray-600">
                    {{totalFarmersSum}}
                </span>
            </div>
        </div>


        <div class="w-full mt-8 bg-white dark:bg-[#363636] ">
            <table
                class="w-full border-collapse border-[1px] rounded-lg border-[#828282] dark:border-gray-700 dark:bg-[white]">
                <thead>
                    <tr class="bg-[#E4DCD3] dark:text-textDark dark:bg-[#0F0F0F] dark:border-[#202021]">
                        <th
                            class="w-1/3 border text-[#000000] dark:text-textDark border-[#828282] dark:border-[#202021] px-4 py-2">
                            Date</th>
                        <th
                            class="w-1/3 border text-[#000000] dark:text-textDark border-[#828282] dark:border-[#202021] px-4 py-2">
                            Total Weight</th>
                        <th
                            class="w-1/3 border text-[#000000] dark:text-textDark border-[#828282] dark:border-[#202021] px-4 py-2">
                            Total Collections</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-[#828282] dark:divide-gray-700 dark:bg-[#1D1D1F]">
                    <tr *ngFor="let item of farmerDataArr"
                        class="divide-x divide-[#828282] dark:divide-gray-700 bg-white dark:bg-[#1D1D1F]">
                        <td class="text-center text-[#000000] dark:text-gray-300 px-4 py-2">
                            {{ item.ReportDate | date: 'yyyy-MM-dd' }}
                        </td>
                        <td class="text-center text-[#000000] dark:text-gray-300 px-4 py-2">
                            {{ item.TotalQty }} kg
                        </td>
                        <td class="text-center text-[#000000] dark:text-gray-300 px-4 py-2">
                            {{ item.TotalFarmers }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <p class="text-[#3F3E3E] dark:text-textDark text-sm mt-4">
                This report is generated on {{ currentDate | date: 'yyyy/MM/dd \'at\' hh:mm a' }}
            </p>

        </div>
    </div>
</div>